import { ConstellationAPI } from "../../constellation";

interface RecordSubject {
    patientId?: string;
    couplePatientId?: string;
    groupPatientId?: string;
}

/**
 * Launches a constellation board for whichever subject the record belongs to:
 * a group board, a couple board, or an individual one.
 */
export async function launchConstellationFor({ patientId, couplePatientId, groupPatientId }: RecordSubject) {
    const { data } = groupPatientId
        ? await ConstellationAPI.launch("group", null, undefined, undefined, undefined, groupPatientId)
        : couplePatientId
          ? await ConstellationAPI.launch("couple", null, couplePatientId)
          : await ConstellationAPI.launch("individual", patientId!);
    return data;
}
